var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 315 229",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41421,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-557 -415)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M812.71 632.27l58.414-134.924c3.897-9.01-5.927-17.922-15.086-13.612-16.113 7.578-37.33 14.25-60.626 14.25-23.428 0-44.865-6.74-61.135-14.37-9.143-4.295-18.944 4.618-15.062 13.62L777.7 632.27c6.46 14.9 28.55 14.9 35 0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 101.948)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557 313.052h315v229H557z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.34 375.554H877v170.944H713.34z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557 482.86h150.57v160.584H557z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 102.304)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.11 391.712l-57.254 134.615c-3.818 8.996 5.824 17.88 14.798 13.588 15.78-7.568 36.555-14.24 59.39-14.24 22.956 0 43.97 6.73 59.92 14.358 8.958 4.278 18.57-4.62 14.743-13.603l-57.314-134.72c-6.308-14.874-27.966-14.874-34.28 0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557 379.696h151v162H557z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M823.472 443.53c0-15.684-12.838-28.384-28.657-28.384-15.796 0-28.634 12.7-28.634 28.384 0 15.662 12.838 28.377 28.634 28.377 15.82 0 28.657-12.715 28.657-28.377z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -136.947)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557 551.947h315v229H557z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M761.18 547.093h67.292v66.762H761.18z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -136.947)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.87 580.477c0-15.685-13.633-28.384-30.45-28.384-16.79 0-30.432 12.7-30.432 28.384 0 15.662 13.64 28.377 30.432 28.377 16.816 0 30.45-12.715 30.45-28.377z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595 551.947h62v57h-62z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.9d339e498e0209cd3929f39b4cab5a47.svg";
export { ForwardRef as ReactComponent };